const Logo = ({ size = 40 }) => (
    <img
        src="/logo.png"
        alt="Shubham Housing logo"
        width={size}
        height={size}
        className="rounded-md"
        data-testid="site-logo-img"
    />
);

export default Logo;
